const initialState = {
    isRemovingSequence: false,
    isHandlingConvert: false,
    isHandlingReassign: false,
    isReadingTasks: false,
    tasksInfo: null
}

export default initialState;
